const preventDataLost = {
    namespaced: true,
    state: {
        isDataChanged: false,
        isModalVisible: false,
        currentPath: null
    },
    mutations: {
        UPDATE_IS_DATA_CHANGED_SUCCESS(state, value) {
            state.isDataChanged = value;
        },
        UPDATE_IS_MODAL_VISIBLE(state, value) {
            state.isModalVisible = value;
        },
        UPDATE_CURRENT_PATH(state, value) {
            state.currentPath = value
        }
    },
    actions: {
        updateDataInFormIsChanged: function({dispatch}, value) {
            dispatch("updateIsDataInFormChanged", value);
        },       
        updateIsModalVisible: function({commit}, value) {
            commit('UPDATE_IS_MODAL_VISIBLE', value);
        },
        updateCurrentPath: function({commit}, value) {
            commit('UPDATE_CURRENT_PATH', value)
        },
        updateIsDataInFormChanged({commit}, value) {
            commit("UPDATE_IS_DATA_CHANGED_SUCCESS", value);
        },
    }
}

export default preventDataLost;
